import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const TITLES = {
  services: "Service pages",
  industries: "Industry pages",
  pages: "All pages",
  articles: "Articles",
  projects: "Work projects",
  positions: "Open positions",
  applications: "Job applications",
  contactMessages: "Contact messages",
  quoteRequests: "Quote requests",
  hostingOrders: "Hosting orders",
  sections: "Page sections",
  section: "Section editor",
};

function resolveTitle(pathname) {
  if (pathname.includes("/industries")) {
    return TITLES.industries;
  }
  if (pathname.includes("/services")) {
    return TITLES.services;
  }
  if (pathname.includes("/hosting-orders")) {
    return TITLES.hostingOrders;
  }
  if (pathname.includes("/quote-requests")) {
    return TITLES.quoteRequests;
  }
  if (pathname.includes("/contact-messages")) {
    return TITLES.contactMessages;
  }
  if (pathname.includes("/applications")) {
    return TITLES.applications;
  }
  if (pathname.includes("/positions")) {
    return TITLES.positions;
  }
  if (pathname.includes("/articles")) {
    return TITLES.articles;
  }
  if (pathname.includes("/projects")) {
    return TITLES.projects;
  }
  if (pathname.includes("/sections/") && !pathname.endsWith("/sections")) {
    return TITLES.section;
  }
  if (pathname.includes("/sections")) {
    return TITLES.sections;
  }
  return TITLES.pages;
}

export default function DashboardLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const title = resolveTitle(location.pathname);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#f4f7f6] text-slate-900">
      {sidebarOpen ? (
        <button
          type="button"
          aria-label="Close menu"
          className="fixed inset-0 z-40 bg-slate-950/60 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}

      <div
        className={`fixed inset-y-0 left-0 z-50 transition-transform duration-200 lg:translate-x-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <Sidebar onNavigate={() => setSidebarOpen(false)} />
      </div>

      <div className="lg:pl-64">
        <Topbar title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
